var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Chart,{attrs:{"options":_setup.FarmFireRiskChartOptionsFactory.make(_vm.farm.risk)}})
}
var staticRenderFns = []

export { render, staticRenderFns }